import React from 'react';
import { Card, Form, Select } from 'antd';
import './styles.css';

const { Option } = Select;

const MultipleSelectCardSociogram = ({
  questionText,
  name,
  required,
  onChange,
  question,
  classMatesOptions,
  answersOptions,
  // hasCompanion,
  hasDependency,
  hasCompanionNames,
}) => {
  return (
    <Card
      title={questionText}
      className="multipleSelectCard_card"
      bordered={!hasDependency}
      style={{ position: 'relative' }}
    >
      <Form.Item
        name={name}
        rules={[
          {
            required,
            message: '*Respuesta obligatoria',
          },
        ]}
      >
        <div id="areaSelect">
          <Select
            mode="multiple"
            showArrow
            style={{ width: '100%' }}
            onChange={(value, options) => onChange(name, question, options)}
            showSearch
            optionFilterProp="children"
            getPopupContainer={() => document.getElementById('areaSelect')}
          >
            {classMatesOptions && classMatesOptions.length && hasCompanionNames
              ? classMatesOptions.map((option) => {
                  return (
                    <Option
                      key={`select-classmate-${option.enrollmentId}`}
                      value={option.enrollmentId}
                    >
                      {option.name}
                    </Option>
                  );
                })
              : answersOptions.map((option) => {
                  return (
                    <Option
                      key={`select-answer-${option.id}`}
                      value={option.name}
                    >
                      {option.name}
                    </Option>
                  );
                })}
          </Select>
        </div>
      </Form.Item>
    </Card>
  );
};

export default MultipleSelectCardSociogram;
